import { render, staticRenderFns } from "./property-form.vue?vue&type=template&id=5198c4d0&"
import script from "./property-form.vue?vue&type=script&lang=js&"
export * from "./property-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports